module.exports = __webpack_public_path__ + "static/media/3pic.22e57c59.png";